<script setup>
import { Head, Link, useForm } from "@inertiajs/vue3";

import VTitleWithBackLink from "@/Shared/VTitleWithBackLink.vue";
import VButtonSubmit from "@/Shared/Buttons/VButtonSubmit";
import VDevider from "@/Shared/VDevider.vue";
import VInputWithLabel from "@/Shared/Form/VInputWithLabel.vue";
import VSelectMultipleWithLabel from "@/Shared/Form/VSelectMultipleWithLabel.vue";
import VInputPasswordWithLabel from "@/Shared/Form/VInputPasswordWithLabel.vue";
import VSelectDefaultWithLabel from "@/Shared/Form/VSelectDefaultWithLabel.vue";
import VUploadPorfilePictureWithLabel from "@/Shared/Form/VUploadPorfilePictureWithLabel.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VAlert from "@/Shared/VAlert.vue";

const props = defineProps({
    roles: Array,
    filters: {
        type: Object,
        default: null,
    },
    urlStore: String,
    urlIndex: String,
});

const form = useForm({
    file_picture: null,
    staf_id: "",
    name: "",
    ic_no: "",
    roles: [],
    status: 1,
    email: "",
    password: "",
    password_confirmation: "",
});

const arrStatus = [
    { id: 1, description: "Active" },
    { id: 0, description: "Non-Active" },
];

const breadcrumbs = [
    {
        url: "/user",
        label: "User Profile",
    },
    {
        url: "#",
        label: "Add New",
    },
];

const submit = () => {
    form.post(props.urlStore, {
        preserveScroll: true,
        forceFormData: true,
    });
};
</script>

<template>
    <Head>
        <title>Add New User - User Profile</title>
    </Head>
    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card mb-3">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <VTitleWithBackLink
                        :href="urlIndex"
                        :filters="filters ?? {}"
                    >
                        Add New User
                    </VTitleWithBackLink>
                </div>
                <VDevider />

                <form @submit.prevent="submit">
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputWithLabel
                                elId="staf_id"
                                label="Staff ID"
                                type="text"
                                :error="form.errors.staf_id"
                                v-model:value="form.staf_id"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputWithLabel
                                elId="name"
                                label="Name"
                                type="text"
                                :error="form.errors.name"
                                v-model:value="form.name"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VSelectMultipleWithLabel
                                elId="role"
                                label="Role"
                                :error="form.errors.roles"
                                v-model:value="form.roles"
                                :options="roles"
                            />
                        </div>

                        <div class="row">
                            <div class="col-lg-6 mb-3">
                                <VSelectDefaultWithLabel
                                    elId="status"
                                    label="Status"
                                    :error="form.errors.status"
                                    v-model:value="form.status"
                                    :options="arrStatus"
                                />
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6">
                                <VInputWithLabel
                                    elId="ic_no"
                                    label="IC No."
                                    type="text"
                                    :error="form.errors.ic_no"
                                    v-model:value="form.ic_no"
                                />
                            </div>
                        </div>
                    </div>
                    <VDevider class="my-4" />

                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputWithLabel
                                elId="email"
                                label="Email"
                                type="email"
                                :error="form.errors.email"
                                v-model:value="form.email"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputPasswordWithLabel
                                elId="password"
                                label="New Password"
                                :error="form.errors.password"
                                v-model:value="form.password"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <VInputPasswordWithLabel
                                elId="password_confirmation"
                                label="New Password Confirmation"
                                :error="form.errors.password_confirmation"
                                v-model:value="form.password_confirmation"
                            />
                        </div>
                    </div>
                    <VDevider class="my-4" />

                    <div class="text-end">
                        <VButtonSubmit
                            type="submit"
                            :isProcessing="form.processing"
                        >
                            Submit
                        </VButtonSubmit>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
